<template>
  <div>
    <h3 class="mb-4">
      <strong>Details</strong>
    </h3>
    <Form
      v-slot="{ errors }"
      @submit="onSubmit"
    >
      <div v-if="formStore.formData.deliveryMethod == 'email' || formStore.formData.deliveryMethod == 'scheduledEmail'">
        <b-form-group>
          <!-- <Field
            v-model="formStore.formData.selfVoucher"
            name="Recipient Type"
            rules="required"
            :class="{ 'is-invalid': errors.selfVoucher }"
            as="b-form-select"
            :options="recipientOptions"
          />
          <ErrorMessage
            name="Recipient Type"
            class="text-danger"
          /> -->
          <b-form-select
            v-model="formStore.formData.selfVoucher"
            :options="recipientOptions"
          />
        </b-form-group> 
      </div>
      <!-- WHO IS IT FROM? -->
      <b-form-group label-class="font-weight-bold">
        <template #label>
          <i class="bi bi-person-fill me-2" /> WHO IS IT FROM?
        </template>
        <Field
          v-model="formStore.formData.from"
          name="from"
          rules="required"
          :class="{ 'is-invalid': errors.from }"
          as="b-form-input"
          placeholder="Your loving sister, Christine"
        />
        <ErrorMessage
          class="text-danger"
          name="from"
        />
      </b-form-group>

      <!-- RECIPIENT'S NAME -->
      <b-form-group
        sub-label="FIRST GIFT"
        label-class="font-weight-bold"
      >
        <template #label>
          <i class="bi bi-person-heart me-2" /> RECIPIENT'S NAME
        </template>
        <Field
          v-model="formStore.formData.recipientName"
          name="recipientName"
          rules="required"
          :class="{ 'is-invalid': errors.recipientName }"
          as="b-form-input"
          placeholder="Bobby Reynolds"
        />
        <ErrorMessage
          class="text-danger"
          name="recipientName"
        />
      </b-form-group>
      <div v-if="formStore.formData.selfVoucher === false && (formStore.formData.deliveryMethod == 'email' || formStore.formData.deliveryMethod == 'scheduledEmail')">
        <b-form-group>
          <template #label>
            <i class="bi bi-envelope me-2" /> RECIPIENT'S EMAIL
          </template>
          <div class="row">
            <div class="col-md-6">
              <Field
                v-model="formStore.formData.recipientEmail"
                name="recipientEmail"
                rules="required|email"
                as="b-form-input"
                placeholder="Enter recipient's Email"
                :class="{ 'is-invalid': errors.recipientEmail }"
              />
              <ErrorMessage
                class="text-danger"
                name="recipientEmail"
              />
            </div>
            <div class="col-md-6">
              <Field
                name="confirmrecipientEmail"
                rules="required|confirmed:@recipientEmail"
                as="b-form-input"
                placeholder="Confirm recipient's Email"
                :class="{ 'is-invalid': errors.confirmrecipientEmail }"
              />
              <ErrorMessage
                class="text-danger"
                name="confirmrecipientEmail"
              />
            </div>
          </div>
        </b-form-group>
      </div>
      <!-- DELIVERY DETAILS (shown only if deliveryOption is 'postal') -->
      <div v-if="formStore.formData.deliveryMethod === 'postal'">
        <h4 class="mb-3 mt-4">
          <strong>Delivery Details</strong>
        </h4>
        <!-- Postal Recipient's Name -->
        <b-form-group
          sub-label="FIRST GIFT"
          label-class="font-weight-bold"
        >
          <template #label>
            <i class="bi bi-person-heart me-2" /> POSTAL RECIPIENT'S NAME
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.postalRecipientName"
            name="postalRecipientName"
            rules="required"
            :class="{ 'is-invalid': errors.postalRecipientName }"
            as="b-form-input"
            placeholder="Bobby Reynolds"
          />
          <ErrorMessage
            class="text-danger"
            name="recipientName"
          />
        </b-form-group>
        <!-- ADDRESS Line 1 -->
        <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-house-fill me-2" /> ADDRESS LINE 1
          </template>
          <Field
            v-slot="{ field }"
            v-model="formStore.formData.deliveryDetails.address1"
            rules="required"
            name="address1"
            :class="{ 'is-invalid': errors.address1 }"
            as="b-form-input"
            type="text"
            placeholder="123 Main St"
          >
            <input v-bind="field">
          </Field>
          <ErrorMessage
            class="text-danger"
            name="address1"
          />
        </b-form-group>

        <!-- ADDRESS Line 2 -->
        <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-house-fill me-2" /> ADDRESS LINE 2
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.address2"
            name="address2"
            as="b-form-input"
            placeholder="123 Main St"
          />
        </b-form-group>

        <!-- CITY -->
        <!-- <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-building-fill me-2" /> CITY
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.city"
            name="city"
            rules="required"
            :class="{ 'is-invalid': errors.city }"
            as="b-form-input"
            placeholder=""
          />
          <ErrorMessage
            class="text-danger"
            name="city"
          />
        </b-form-group> -->

        <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-house-fill me-2" /> CITY
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.city"
            name="city"
            rules="required"
            :class="{ 'is-invalid': errors.city }"
            as="b-form-input"
            placeholder="123 Main St"
          />
          <ErrorMessage
            class="text-danger"
            name="city"
          />
        </b-form-group>

        <!-- STATE/PROVINCE -->
        <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-map-fill me-2" /> STATE/PROVINCE
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.state"
            name="state"
            rules="required"
            :class="{ 'is-invalid': errors.state }"
            as="b-form-input"
            placeholder="NY"
          />
          <ErrorMessage
            class="text-danger"
            name="state"
          />
        </b-form-group>

        <!-- POSTAL CODE -->
        <b-form-group label-class="font-weight-bold">
          <template #label>
            <i class="bi bi-mailbox me-2" /> POSTAL CODE
          </template>
          <Field
            v-model="formStore.formData.deliveryDetails.postalCode"
            name="postalCode"
            rules="required"
            :class="{ 'is-invalid': errors.postalCode }"
            as="b-form-input"
            placeholder="10001"
          />
          <ErrorMessage
            class="text-danger"
            name="postalCode"
          />
        </b-form-group>

        <!-- COUNTRY -->
        <b-form-group
          label="Select Country:"
          label-class="font-weight-bold"
        >
          <Field
            v-slot="{ field }"
            name="country"
            rules="required"
          >
            <b-form-select
              v-bind="field"
              v-model="formStore.formData.deliveryDetails.country"
              :class="{ 'is-invalid': errors.country }"
              :options="countryOptions"
            />
          </Field>
          <ErrorMessage
            class="text-danger"
            name="country"
          />
        </b-form-group>
      </div>
      <!-- GIFT MESSAGE -->
      <b-form-group
        sub-label="OPTIONAL"
        label-class="font-weight-bold"
      >
        <template #label>
          <i class="bi bi-chat-left-heart-fill me-2" /> GIFT MESSAGE
        </template>
        <Field
          v-model="formStore.formData.giftMessage"
          name="giftMessage"
          rules="max:300"
          :class="{ 'is-invalid': errors.giftMessage }"
          as="b-form-textarea"
          placeholder="Thanks for being there."
          rows="3"
        />
        <small class="text-muted mt-1 mb-4 d-block">
          Enter up to 300 characters ({{
            300 - (formStore.formData.giftMessage || "").length
          }}
          remaining)
        </small>

        <b-form-checkbox v-model="formStore.formData.hideDetails">
          Do not display To, From and Gift Message Details on the voucher.
        </b-form-checkbox>
        <ErrorMessage
          class="text-danger"
          name="giftMessage"
        />
      </b-form-group>
      <!-- <div v-if="formStore.formData.selfVoucher === false && formStore.formData.deliveryMethod === 'email'">
        <h5 class="mb-3 mt-4">
          <strong>SEND LATER</strong>
          <b-form-checkbox
            v-model="formStore.formData.scheduleLater"
            switch
            size="lg"
          />
        </h5>

        <div v-if="formStore.formData.scheduleLater">
          <p class="time-desc">
            When should we deliver the voucher?
          </p>
          <Field
            v-slot="{}"
            v-model="formStore.formData.scheduleDate"
            name="Schedule Date"
            :rules="'required'"
          >
            <datetime
              format="DD/MM/YYYY H:i"
              width="300px"
              class="mb-4 mt-1"
              @input="handleDateChange"
            />
          </Field>

          <ErrorMessage
            class="text-danger"
            name="Schedule Date"
          />
        </div>

        <p class="time-desc">
          If you leave this switched off, your order will be delivered immediately
        </p>
      </div> -->

      <!-- <div v-if="formStore.formData.deliveryMethod === 'scheduledEmail'">
        <h5 class="mb-3 mt-4">
          <strong>SEND LATER</strong>
          <b-form-checkbox
            v-model="formStore.formData.deliveryDetails.scheduleLater"
            switch
            size="lg"
          />
          <p class="time-desc">
            When should we deliver the voucher?
          </p>
          <Field
            v-slot="{}"
            v-model="formStore.formData.deliveryDetails.scheduleDate"
            name="scheduleDate"
            :rules="formStore.formData.deliveryDetails.scheduleLater ? 'required' : ''"
          >
            <datetime
              v-if="formStore.formData.deliveryDetails.scheduleLater"
              format="DD/MM/YYYY H:i"
              width="300px"
              class="mb-4 mt-1"
              @input="handleDateChange"
            />
          </Field>
          <ErrorMessage
            class="text-danger"
            name="scheduleDate"
          />
          <p class="time-desc">
            If you leave this switched off, your order will be delivered immediately
          </p>
        </h5>
      </div> -->
      <div v-if="formStore.formData.deliveryMethod === 'scheduledEmail' || (formStore.formData.selfVoucher === false && formStore.formData.deliveryMethod === 'email')">
        <h5 class="mb-3 mt-4">
          <strong>SEND LATER</strong>
          <b-form-checkbox
            v-model="formStore.formData.deliveryDetails.scheduleLater"
            switch
            size="lg"
          />
        </h5>

        <div v-if="formStore.formData.deliveryDetails.scheduleLater">
          <p class="time-desc">
            When should we deliver the voucher?
          </p>
          <div :class="{ 'is-invalid': errors.scheduleDate }">
            <Field
              v-slot="{ field }"
              name="scheduleDate"
              :rules="'requiredDate'"
              class="date-time-input"
            >
              <flat-pickr                
                :config="pickerConfig"
                v-bind="field"
                :value="selectedDate"
                class="form-control date-picker"                
                placeholder="Select date & time"
                @update:model-value="val => onDateSelected(val, field)"
                @on-close="val => {
                  field.onChange(val);
                  selectedDate = val; // sync to computed/store
                }"
              />
            </Field>
 
            <ErrorMessage
              class="text-danger"
              name="scheduleDate"
            />
          </div>
          <p
            class="time-desc"
          />
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          variant="light"
          @click="formStore.prevStep"
        >
          BACK
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="Object.keys(errors).length > 0"
        >
          NEXT
        </b-button>
      </div>
    </Form>
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
import { required, max } from "@vee-validate/rules";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
defineRule("required", required);
defineRule("max", max);
defineRule("requiredDate", value => {
  if (!value) return "This field is required";

  if (value instanceof Date && !isNaN(value.getTime())) return true;

  if (typeof value === "string" && value.trim() !== "") return true;

  return "This field is required";
});
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    // datetime,
    flatPickr
  },
  data() {
    return {
      formStore: useFormStore(),
      countryOptions: ['Ireland'],
      recipientOptions: [
        { value: true, text: 'Send the voucher to me' },
        { value: false, text: 'Send the voucher to someone else' }
      ],
      showPicker: true
    };
  },
  computed: {
    selectedDate: {
      get() {
        const v = this.formStore.formData.deliveryDetails.scheduleDate;
        if (v instanceof Date) return v;
        if (typeof v === 'string' && v) return new Date(v);
        return null;
      },
      set(val) {
        this.formStore.formData.deliveryDetails.scheduleDate = val instanceof Date ? val : null;
      }
    },
    pickerConfig() {
      return {
        enableTime: true,
        time_24hr: true,
        dateFormat: "d/m/Y H:i",   
        altInput: true,
        minDate: new Date(Date.now() + 60 * 60 * 1000),
        disableMobile: true,
        //defaultDate: new Date(Date.now() + 60 * 60 * 1000),
        plugins: [
          this.okButtonPlugin((val) => {
            // Handle OK press
            this.formStore.formData.deliveryDetails.scheduleDate =
              this.formatDateForStorage(val);
          })
        ],
        parseDate(datestr) {
          if (!datestr) return null;
          const [datePart, timePart] = datestr.split(" ");
          const [day, month, year] = datePart.split("/").map(Number);
          const [hour, minute] = timePart.split(":").map(Number);
          return new Date(year, month - 1, day, hour, minute);
        },

        // Display as DD/MM/YYYY H:i
        formatDate(date) {
          const pad = (n) => n.toString().padStart(2, "0");
          return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
      };
    },
  },
  watch: {
    'formStore.formData.deliveryDetails.scheduleLater'(val) {
      if (!val) {
        this.formStore.formData.deliveryDetails.scheduleDate = null;
      }
    }
  },
  methods: {
    onSubmit() {
      this.formStore.nextStep();
    },
    handleDateChange(value) {
      this.formStore.formData.deliveryDetails.scheduleDate = value;
    },
  
    okButtonPlugin(onOk) {
      return function(fp) {
        const button = document.createElement("button");
        button.textContent = "OK";
        button.type = "button";
        button.classList.add("flatpickr-ok-button");

        button.addEventListener("click", () => {
          if (fp.selectedDates.length > 0) {
            onOk(fp.selectedDates[0]);
            fp.close();
          }
        });

        return {
          onReady() {
            fp.calendarContainer.appendChild(button);
          }
        };
      };
    },
    formatDateForStorage(date) {
      const pad = n => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
    },

    onDateSelected(val, field) {
      field.value = val;

      this.formStore.formData.deliveryDetails.scheduleDate = val;
    },   
  }
  
};
</script>

<style scoped>
.is-invalid {
  border-color: #dc3545;
}

.text-danger {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

</style>
<style>

.year-month-wrapper{
  background-color: #0d6efd !important;
}
.nav-r,.nav-l, .activePort{
  background-color: #0d6efd !important;
}
.days, .okButton {
    color: #0d6efd !important;
}
.time-desc{
  font-size: 16px;
}
.recipient-email{
  display: flex;
  gap: 15px;
}
#tj-datetime-input{
      max-width: 250px;
    margin-bottom: 15px;
}
.flatpickr-time.time24hr .numInputWrapper {
    width: 50px !important;
}
.flatpickr-calendar.hasTime .flatpickr-time{
  display: block !important;
}
.flatpickr-ok-button {
  width: 100%;
  padding: 8px;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
}
.date-picker {
  width: 50% !important;
}
.is-invalid .date-picker{
  border-color:#dc3545;
}
@media (max-width: 768px) {
  .date-picker {
    width: 100% !important;
  }
}
</style>